import * as actionTypes from "../ActionTypes/wishlist";

export interface WishlistAction {
  type: string;
  data?: any;
  callback?: any;
}

export const fetchWishlistData = (data: string, callback?: any): WishlistAction => {
  return {
    type: actionTypes.FETCH_WISHLIST_DATA,
    data,
    callback,
  };
};

export const fetchWishlistCategoryList = (callback?: any) => {
  return {
    type: actionTypes.FETCH_WISHLIST_CATEGORY_LIST,
    callback,
  };
};

export const fetchCustomerWishlistItems = (data: any, callback?: any): WishlistAction => {
  return {
    type: actionTypes.FETCH_CUSTOMER_WISHLIST_ITEMS,
    data,
    callback,
  };
};

export const generateWishlistItemReport = (data: any, callback?: any): WishlistAction => {
  return {
    type: actionTypes.GENERATE_WISHLIST_ITEM_REPORT,
    data,
    callback,
  };
};

export const generateWishlistStoreReport = (data: any, callback?: any): WishlistAction => {
  return {
    type: actionTypes.GENERATE_WISHLIST_STORE_REPORT,
    data,
    callback,
  };
};

export const saveWishlistData = (data) => {
  return {
    type: actionTypes.SAVE_WISHLIST_DATA,
    data,
  };
};

export const setWishlistFlag = (data: any, callback?: any) => {
  return {
    type: actionTypes.SET_WISHLIST_FLAG,
    data,
    callback,
  };
};

export const sendWishlistReminder = (data: any, callback?: any) => {
  return {
    type: actionTypes.SEND_WISHLIST_REMINDER,
    data,
    callback,
  };
};
